import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../../video/Mariniz Logo Gold.png";
import admin from "../AdminImage/user3jpeg.jpeg";
import { motion } from "framer-motion";

export default function AdminNav() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const [isScrolled, setIsScrolled] = useState(false);

  // Track scrolling
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50); // Adjust the value to when you want the effect
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Automatically flip twice on page load
  const handleFlip = () => {
    setIsFlipped(false); // Temporarily set to false
    setTimeout(() => setIsFlipped((prevState) => !prevState), 10); // Reapply the flipped state
  };

 const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("admin");
    window.location.href = "/login"; // redirect to login
  };

  const scrollToTop = () => {
    window.location.href = "/adminHome"
    
  };

  
  const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
  
    // Toggle dropdown
    const toggleDropdownprofile = (e) => {
      e.stopPropagation(); // Prevent click event from bubbling
      setIsOpen((prev) => !prev);
    };
  
    // Close dropdown when clicking outside
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
  
      document.addEventListener("click", handleClickOutside);
      return () => document.removeEventListener("click", handleClickOutside);
    }, []);

  return (
    <div>
      <nav>
        <div className="bg-[#123d5f]   border-b border-white">
        <div className="px-[130px] sm:px-[10px]  3xl:px-[40px] py-2 flex justify-end items-center xs:justify-center">
           
           <div className="flex items-center  gap-2 ">
            
             <div className="flex ml-auto gap-4 items-center px-3 ">
               <Link
                 to={"https://www.facebook.com/groups/2708905909353211"}
                 className=" "
               >
                 <i class="fa-brands hover:scale-125 duration-200 hover:text-blue-400  fa-facebook text-2xl text-blue-600"></i>
               </Link>
               <Link to={"https://www.instagram.com/data.marine/?hl=en"}>
                 <i class="fa-brands fa-instagram hover:scale-125 duration-200 hover:text-pink-400 text-2xl text-pink-500"></i>
               </Link>
               <Link
                 target="_blank"
                 to={
                   "https://wa.me/971503505898?text=Hello%20Happy%20Marine%20Shipping,%20I%20would%20like%20to%20inquire%20about%20your%20services."
                 }
               >
                 <i class="fa-brands fa-whatsapp hover:scale-125 duration-200 hover:text-green-400 text-2xl text-green-500"></i>
               </Link>
             </div>
           </div>
         </div>
        
         <hr className="border-1 hidden L:block border-white " />
         

         <div
  className={`flex items-center ${
    isScrolled
      ? "fixed top-0 left-0 w-full bg-[#123d5f] text-[#d1a460] hover:text-blue-500 shadow-md z-50 pointer-events-auto"
      : ""
  }`}
>
  <div
    className={`md:mt-0 2xl:mt-1 mt-5 mb-5 pl-14 xl:pl-0 h-[75px] bg-[#123d5f] text-[#d1a460] border-l border-t border-b items-center border-r rounded-r-full L:border-none 2xl:shadow-none  md:border-none shadow-xl 2xl:w-full transition-all duration-300 w-[95%] md:w-full L:px-5 flex justify-between  relative`}
  >
    {/* Left Section: Menu Icon and Logo */}
    
     
      <Link to={"/adminHome"} className="L:m-auto" onClick={scrollToTop}>
        <img
          src={Logo}
          className="w-[270px]   xl:w-[220px] object-contain cursor-pointer"
          alt="Logo"
        />
      </Link>

      <div className="">
        <i
          onClick={toggleSidebar}
          className={`bx ${isSidebarOpen ? "bx-x" : "bx-menu"} hidden L:block  mt-5 text-white text-[40px] cursor-pointer`}
        ></i>
      </div>
  

    {/* Right Section: Navigation Links */}
    <div className="L:hidden flex items-center  xl:gap-4  gap-10">
     
      <Link
        to="/adminShipForSale"
        onClick={() => (window.location.href = "/adminShipForSale")}
        className={`text-sm transition-all duration-300 ${
          isScrolled ? "hover:text-blue-500" : "hover:text-white"
        }`}
      >
        Ship Sale/Purchase
      </Link>
      <Link
        to="/map/ship-chartering"
         onClick={() => (window.location.href = "/map/ship-chartering")}
        className={`text-sm transition-all duration-300 ${
          isScrolled ? "hover:text-blue-500" : "hover:text-white"
        }`}
      >
        Open Ships
      </Link>
      <Link
        to="/map/open-cargo"
        onClick={() => (window.location.href = "/map/open-cargo")}
        className={`text-sm transition-all duration-300 ${
          isScrolled ? "hover:text-blue-500" : "hover:text-white"
        }`}
      >
        Open Cargo
      </Link>
      <Link
        to="/adminSupplyEq"
        onClick={() => (window.location.href = "/adminSupplyEq")}
        className={`text-sm transition-all duration-300 ${
          isScrolled ? "hover:text-blue-500" : "hover:text-white"
        }`}
      >
        Supply Equipments
      </Link>
      <Link
        to="/admincontact"
        onClick={() => (window.location.href = "/admincontact")}
        className={`text-sm transition-all duration-300 ${
          isScrolled ? "hover:text-blue-500" : "hover:text-white"
        }`}
      >
        Contact Us
      </Link>
      

<div className="relative ml-auto  flex items-center gap-20">
         
          {/* Admin Image */}
          <div>
            <img
              src={admin} // Replace with {admin} if using a variable
              className="rounded-full w-[50px] h-[50px] cursor-pointer"
              alt="admin"
              onClick={toggleDropdownprofile}
            />
            {/* Dropdown */}
            {isOpen && (
              <motion.div
                ref={dropdownRef}
                initial={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                animate={{ opacity: 1, rotateX: 0, scale: 1 }}
                exit={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="absolute right-0 mt-2 bg-white shadow-lg rounded-md w-40 py-2 origin-top transform"
              >
                <ul className="text-gray-700">
                  <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                    <Link to="/login/Dashboard">Dashboard</Link>
                  </li>
                  <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                  <button onClick={handleLogout} className="text-red-500"><i class='bx bx-log-out'></i> Logout</button>
                  </li>
                </ul>
              </motion.div>
            )}
          </div>
        </div>
      
    </div>


    {/* CTA Button on smaller screens only */}
    <Link
          to="/regShip"
          className="h-[75px] L:hidden shadow-xl py-2 bg-[#d1a460] hover:bg-[#806338] transition-all border rounded-r-full"
        >
          <p className="text-sm transition-all duration-300 text-black rounded p-4">
            + Register your Ship
          </p>
        </Link>
  </div>

  {/* Sidebar for small screens */}
  <div
  className={`fixed top-0 right-0 h-full bg-gray-100 shadow-lg transform ${
    isSidebarOpen ? "translate-x-0" : "translate-x-full"
  } transition-transform duration-300 z-50 w-[250px]`}
>
  <div className="p-4">
    <div className="flex justify-between">
      <h2 className="text-lg font-bold mb-4">Menu</h2>
      <p onClick={toggleSidebar}>
        <i className="fa-solid fa-circle-chevron-right text-xl"></i>
      </p>
    </div>
    <ul className="space-y-4">
      <li><Link to="/" className="text-blue-500 block" onClick={toggleSidebar}>Home</Link></li>
      <li><Link to="/login/Dashboard" className="text-gray-800 hover:text-blue-300 block" onClick={toggleSidebar}>Dashboard</Link></li>
      <li><Link to="/adminShipForSale" className="text-gray-800 hover:text-blue-500 block" onClick={toggleSidebar}>Ship Sale/Purchase</Link></li>
      <li><Link to="/map/ship-chartering" className="text-gray-800 hover:text-blue-500 block" onClick={toggleSidebar}>Open ships</Link></li>
      <li><Link to="/map/open-cargo" className="text-gray-800 hover:text-blue-300 block" onClick={toggleSidebar}>Open Cargo</Link></li>
      <li><Link to="/adminSupplyEq" className="text-gray-800 hover:text-blue-300 block" onClick={toggleSidebar}>Supply Equipments</Link></li>
      
            <li><Link to="/regShipadmin" className="bg-[#d1a460] text-black hover:bg-[#af9164] rounded py-2 px-2 block text-center" onClick={toggleSidebar}>+ Register your Ship</Link></li>
        <Link
        to="/"
        className={` w-[100px]  text-center  p-2 py-3  transition-all duration-300 `}
      >
       <i className="fa-solid float-end mt-3  text-2xl font-semibold fa-right-from-bracket text-red-500"></i>
      </Link>
    </ul>
  </div>
</div>

</div>


        </div>
      </nav>
    </div>
  );
}
